/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { useNavigation } from '@react-navigation/native';
import { RefreshControl, Text, TouchableOpacity, View } from 'react-native';
import { settingsStyles as styles } from './settingsScreen.styles';
import { ShellScrollScreen } from '../../shared/layout/ShellScrollScreen'
import { ShellScreenLoading } from '../../shared/layout/ShellScreenLoading'
import { useContentLayout } from '../../shared/layout/useContentLayout';
import { useMercadoPagoBranchSettingsScreen } from './useMercadoPagoBranchSettingsScreen';
import { MercadoPagoBranchSettingsPanel } from './components/MercadoPagoBranchSettingsPanel';
import { SettingsScreenHero } from './components/settingsScreenLayout';
import { useScreenLoadShell } from '../../shared/ui/hooks-screen/useScreenLoad';
import { ticketColors } from '../../shared/theme/ticketColors';

export const MercadoPagoBranchSettingsScreen = () => {
  const vm = useMercadoPagoBranchSettingsScreen({ oauthReturnShellRoute: 'MercadoPagoBranchSettings' });
  const navigation = useNavigation<any>();
  const { layoutWebShell } = useContentLayout('settings');
  const widthVariant = layoutWebShell ? 'settingsWide' : 'settings';

  const { refreshing, onRefresh } = useScreenLoadShell(
    'MercadoPagoBranchSettings',
    async (opts) => { await vm.load(opts); }
  );

  const gateContent = !vm.currentBranchId ? (
    <View style={styles.card}>
      <Text style={styles.title}>Seleccioná una sucursal</Text>
      <Text style={styles.captionBlock}>Elegí un local activo y volvé a abrir Mercado Pago.</Text>
      <TouchableOpacity style={styles.primaryButton} onPress={() => navigation.goBack()} accessibilityRole="button">
        <Text style={styles.primaryButtonText}>Volver</Text>
      </TouchableOpacity>
    </View>
  ) : !vm.mercadoPagoIntegrationsEnabled ? (
    <View style={styles.card}>
      <Text style={styles.title}>No disponible</Text>
      <Text style={styles.captionBlock}>Mercado Pago está apagado por ahora.</Text>
      <TouchableOpacity style={styles.primaryButton} onPress={() => navigation.goBack()} accessibilityRole="button">
        <Text style={styles.primaryButtonText}>Volver</Text>
      </TouchableOpacity>
    </View>
  ) : !vm.canView ? (
    <View style={styles.card}>
      <Text style={styles.title}>Sin permiso</Text>
      <Text style={styles.captionBlock}>
        Pedile al dueño que te habilite «Ajustes de sucursal».
      </Text>
      <TouchableOpacity style={styles.primaryButton} onPress={() => navigation.goBack()} accessibilityRole="button">
        <Text style={styles.primaryButtonText}>Volver</Text>
      </TouchableOpacity>
    </View>
  ) : vm.loading ? (
    <ShellScreenLoading label="Cargando…" />
  ) : null;

  return (
    <ShellScrollScreen
      widthVariant={widthVariant}
      refreshControl={
        vm.currentBranchId && vm.canView && !vm.loading ? (
          <RefreshControl
            refreshing={refreshing}
            onRefresh={onRefresh}
            colors={[ticketColors.gold]}
            tintColor={ticketColors.gold}
          />
        ) : undefined
      }
    >
      {gateContent ?? (
        <>
          <SettingsScreenHero
            kicker="Mercado Pago"
            lead={vm.currentBranch?.name ?? 'Sucursal activa'}
          />
          <MercadoPagoBranchSettingsPanel vm={vm} variant="screen" />
        </>
      )}
    </ShellScrollScreen>
  );
};
